export default {

  clearAll(state){
    state.data.accessToken = null
    state.data.refreshToken = null
    state.loginEmail = null
    state.loginPassword = null

    state.forms.login.fields.email = null
    state.forms.login.fields.password = null
  },

  clearAccessToken(state, email) {
    state.data.accessToken = null
  },

  clearRefreshToken(state, email) {
    state.data.refreshToken = null
  },

  setLoginEmail(state, email) {
    state.loginEmail = email
  },

  setLoginPassword(state, password) {
    state.loginPassword = password
  },

  setTokenDataFromAPI(state, data) {
    state.data.accessToken = data.access_token
    state.data.refreshToken = data.refresh_token
  },

  setTokenDataFromStorage(state, data) {
    state.data = data
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/token/mutations.js